/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The possible component preview function input data types.
 * @export
 */
export type ComponentPreviewInputType = ComponentPreviewInputTypeFile | ComponentPreviewInputTypeInline;

/**
 * The file input data type.
 * @export
 */
export type ComponentPreviewInputTypeFile = typeof COMPONENT_PREVIEW_INPUT_TYPE_FILE;

/**
 * The inline input data type.
 * @export
 */
export type ComponentPreviewInputTypeInline = typeof COMPONENT_PREVIEW_INPUT_TYPE_INLINE;

/**
 * The file input data constant.
 * @export
 */
export const COMPONENT_PREVIEW_INPUT_TYPE_FILE = 'file';

/**
 * The inline input data constant.
 * @export
 */
export const COMPONENT_PREVIEW_INPUT_TYPE_INLINE = 'inline';
